import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleInfo } from 'Images';

interface ISubtitle {
  isNoDataError: boolean;
  isEdit: boolean;
}

export const Subtitle = ({ isNoDataError, isEdit }: ISubtitle) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements).form;
  const isDesktop = useIsDesktop();

  return isNoDataError ? (
    <Stack flexDirection={'row'} gap={'8px'}>
      <Avatar sx={{ width: '24px', height: '24px' }} alt='' src={PurpleInfo} />
      <Typography variant='body2'>{dictionary.noDataError}</Typography>
    </Stack>
  ) : (
    <Typography
      textAlign={isDesktop ? undefined : 'center'}
      alignSelf={isDesktop ? undefined : 'center'}
      maxWidth={isDesktop ? undefined : '21ch'}
      component={'h2'}
      variant={'h6'}
      sx={isDesktop ? undefined : { fontWeight: 400, lineHeight: '24px' }}
    >
      {isEdit ? dictionary.editSubtitle : dictionary.subtitle}
    </Typography>
  );
};
